import React, { useState } from 'react';
import { Send, Mail, User, MessageSquare } from 'lucide-react';
import { Helmet } from 'react-helmet-async';
import './ContactForm.css';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [sending, setSending] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSending(true);
    setError(false);
    
    try {
      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          access_key: '11c0a4ab-ec86-416a-9a30-1201b66ac3cb', //Web3Forms access key
          name: formData.name,
          email: formData.email,
          message: formData.message,
          subject: 'Quantumke Website Contact Form Submission',
        }),
      });
      
      const data = await response.json();
      
      if (data.success) {
        setSuccess(true);
        setFormData({ name: '', email: '', message: '' });
        // Reset form after showing success message
        setTimeout(() => {
          setSuccess(false);
        }, 5000);
      } else {
        setError(true);
      }
    } catch (err) {
      console.error("Error submitting form:", err);
      setError(true);
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="contact-container">
      <Helmet>
        <title>Contact Us | QuantumKE</title>
        <meta name="description" content="Get in touch with the QuantumKE team. We welcome partnerships, collaboration proposals, and inquiries from researchers, students, and organizations." />
        <link rel="canonical" href="https://quantumke.org/contact-us" />
      </Helmet>
      <div className="contact-card">
    
        {/* Title */}
        <div className="contact-title">
          <h1>Let's chat.</h1>
          <p>We'd love to hear from you.</p>
        </div>
        
        {/* Form */}
        <form onSubmit={handleSubmit} className="contact-form">
          <div className="form-group">
            <label>NAME</label>
            <div className="input-wrapper">
              <span className="input-icon">
                <User size={18} />
              </span>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="John Doe"
                required
              />
            </div>
          </div>
          
          <div className="form-group">
            <label>EMAIL</label>
            <div className="input-wrapper">
              <span className="input-icon">
                <Mail size={18} />
              </span>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="example@domain.com"
                required
              />
            </div>
          </div>
          
          <div className="form-group">
            <label>MESSAGE</label>
            <div className="input-wrapper">
              <span className="input-icon textarea-icon">
                <MessageSquare size={18} />
              </span>
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder="How can we help you?"
                rows="4"
                required
              ></textarea>
            </div>
          </div>
          
          <div className="button-container">
            <button
              type="submit"
              disabled={sending || success}
              className={`submit-button ${success ? 'success' : ''} ${error ? 'error' : ''}`}
            >
              {sending ? (
                <span className="button-content">
                  <div className="spinner"></div>
                  Sending...
                </span>
              ) : success ? (
                <span className="button-content">
                  Message sent!
                </span>
              ) : error ? (
                <span className="button-content">
                  Error! Try again
                </span>
              ) : (
                <span className="button-content">
                  Send message
                  <Send size={18} className="send-icon" />
                </span>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ContactForm;